import auth from '../../../middleware/auth.js';
import shortcuts from '../../../middleware/shortcuts.js';
import {appHelper} from "../../../utils/helpers/appHelper.js";
import {elementHelper} from "../../../utils/helpers/elementHelper.js";
import {routeHelper} from "../../../utils/helpers/routeHelper.js";
export const AdminModules = [
    {
        path: appHelper.path.adminApp + '/module',
        // component: () => import('../../../views/layout/NavTab.vue'),
        component: () => {
            elementHelper.loader.show('body_loader', window.document.body);
            return import('../../../views/layout/NavTab.vue').finally(() => {
                elementHelper.loader.hide('body_loader');
            });
        },
        meta: { middleware: [auth] },
        children: [
            {
                name: 'module',
                path: '',
                component: routeHelper.asyncComponentWithLoader(() => import('../views/modules/index.vue')),
                meta: { middleware: [auth, shortcuts] }
            },
            {
                name: 'module-features',
                path: 'feature',
                component: routeHelper.asyncComponentWithLoader(() => import('../views/features/index.vue')),
                meta: { middleware: [auth, shortcuts] }
            },
            {
                name: 'category',
                path: 'category',
                component: routeHelper.asyncComponentWithLoader(() => import('../views/categories/index.vue')),
                meta: { middleware: [auth, shortcuts] }
            },
            {
                name: 'permission',
                path: 'permission',
                component: routeHelper.asyncComponentWithLoader(() => import('../views/permissions/index.vue')),
                meta: { middleware: [auth, shortcuts] }
            },
            {
                name: 'app-menu',
                path: 'app-menu',
                component: routeHelper.asyncComponentWithLoader(() => import('../views/app-menu/index.vue')),
                meta: { middleware: [auth, shortcuts] }
            },
            {
                name: 'mobile-menu',
                path: 'mobile-menu',
                component: routeHelper.asyncComponentWithLoader(() => import('../views/mobile-menu/index.vue')),
                meta: { middleware: [auth, shortcuts] }
            }
        ]
    }
];
